"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePaymentPlanToJSON = exports.InvoicePaymentPlanFromJSONTyped = exports.InvoicePaymentPlanFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function InvoicePaymentPlanFromJSON(json) {
    return InvoicePaymentPlanFromJSONTyped(json, false);
}
exports.InvoicePaymentPlanFromJSON = InvoicePaymentPlanFromJSON;
function InvoicePaymentPlanFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': !(0, runtime_1.exists)(json, 'text') ? undefined : json['text'],
        'value': !(0, runtime_1.exists)(json, 'value') ? undefined : (0, _1.AmountFromJSON)(json['value']),
    };
}
exports.InvoicePaymentPlanFromJSONTyped = InvoicePaymentPlanFromJSONTyped;
function InvoicePaymentPlanToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'value': (0, _1.AmountToJSON)(value.value),
    };
}
exports.InvoicePaymentPlanToJSON = InvoicePaymentPlanToJSON;
//# sourceMappingURL=InvoicePaymentPlan.js.map